<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('getInStockInfo.queryCondition') }}</div>
      </div>
      <div class="">
        <el-form :inline="true" :model="getInStockInfoManageInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-date-picker v-model="getInStockInfoManageInfo.conditions.beginTime" type="datetime" placeholder="开始时间"
              value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%" />
          </el-form-item>
          <el-form-item>
            <el-date-picker v-model="getInStockInfoManageInfo.conditions.endTime" type="datetime" placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%" />
          </el-form-item>
          <el-form-item>
            <el-input v-model="getInStockInfoManageInfo.conditions.prodNameLike" placeholder="商品名称" clearable
              style="width: 100%" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="_queryGetInStockInfoMethod">
              <i class="el-icon-search"></i> {{ $t('common.query') }}
            </el-button>
            <el-button type="primary" size="small" @click="_resetGetInStockInfoMethod">
              <i class="el-icon-refresh"></i> {{ $t('common.reset') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('getInStockInfo.stockStatistics') }}</div>
      </div>
      <div class="">
        <el-table :data="getInStockInfoManageInfo.getInStockInfos" border style="width: 100%">
          <el-table-column prop="barCode" label="条形码" align="center" />
          <el-table-column prop="prodName" label="商品名称" align="center" />
          <el-table-column prop="specName" label="规格名称" align="center" />
          <el-table-column prop="prodCount" label="库存" align="center">
            <template #default="{ row }">
              {{ row.prodCount || 0 }}
            </template>
          </el-table-column>
          <el-table-column prop="actCount" label="入库" align="center">
            <template #default="{ row }">
              {{ row.actCount || 0 }}
            </template>
          </el-table-column>
          <el-table-column prop="price" label="单价" align="center">
            <template #default="{ row }">
              {{ row.price || 0 }}
            </template>
          </el-table-column>
          <el-table-column prop="unitName" label="单位" align="center" />
          <el-table-column prop="amount" label="入库金额" align="center">
            <template #default="{ row }">
              {{ row.amount || 0 }}
            </template>
          </el-table-column>
          <el-table-column prop="tActCount" label="退货数量" align="center">
            <template #default="{ row }">
              {{ row.tActCount || 0 }}
            </template>
          </el-table-column>
          <el-table-column prop="tAmount" label="退货金额" align="center">
            <template #default="{ row }">
              {{ row.tAmount || 0 }}
            </template>
          </el-table-column>
        </el-table>

        <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
          :total="total" layout="total, prev, pager, next, jumper" style="margin-top: 20px; text-align: right" />
      </div>
    </el-card>
  </div>
</template>

<script>
import { getInStockInfoList } from '@/api/goods/getInStockInfoApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'GetInStockInfoManage',
  data() {
    return {
      getInStockInfoManageInfo: {
        getInStockInfos: [],
        total: 0,
        records: 1,
        conditions: {
          beginTime: '',
          endTime: '',
          prodNameLike: '',
          shopId: ''
        }
      },
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  created() {
    this.getInStockInfoManageInfo.conditions.shopId = getShopId()
    this._lisGetInStockInfos(this.currentPage, this.pageSize)
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val
      this._lisGetInStockInfos(val, this.pageSize)
    },
    async _lisGetInStockInfos(page, rows) {
      const params = {
        ...this.getInStockInfoManageInfo.conditions,
        page,
        row: rows
      }
      params.prodNameLike = params.prodNameLike.trim()

      try {
        const res = await getInStockInfoList(params)
        this.getInStockInfoManageInfo.getInStockInfos = res.data
        this.getInStockInfoManageInfo.total = res.total
        this.getInStockInfoManageInfo.records = res.records
        this.total = res.total
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _queryGetInStockInfoMethod() {
      this.currentPage = 1
      this._lisGetInStockInfos(this.currentPage, this.pageSize)
    },
    _resetGetInStockInfoMethod() {
      this.getInStockInfoManageInfo.conditions = {
        beginTime: '',
        endTime: '',
        prodNameLike: '',
        shopId: this.getInStockInfoManageInfo.conditions.shopId
      }
      this.currentPage = 1
      this._lisGetInStockInfos(this.currentPage, this.pageSize)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}

.ibox-title {
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
}

.ibox-content {
  padding: 20px;
}
</style>